/**
 * Created by Jaime Bonilla Venegas on 2017-06-20.
 *
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import TabuladorCustomForm from '../../forms/customTabulador';
import { ClientesFilter } from '../../components/filters';
import { serializeParams } from '../../common/helpers';
import Snackbar from 'material-ui/Snackbar';
import {
    getPagePermissions,
    hasCreatePermission,
    hasReadPermission,
    CUSTOMERS_PERMISSION,
    TABULAR_PRICES_PERMISSION
} from '../../security/permissions';
import { isExecutive } from '../../security/role.validator';

class Clientes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showErrors: false,
            validationErrors: {},
            showNotification: false,
            showMessage: ''
        }
    }

    componentWillMount() {
        this.props.fetchData('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name', ['executiveUser.id']: isExecutive() ? this.props.userData.userId : '' });
        this.props.fetchCustomsHousesData('customsHouses', 'customsHouses', 'customsHouses/search/findAllByOrderByNameAsc');
        this.props.fetchExecutiveUsersData('users', 'executiveUsers', 'users/search/findByRoleAndActive', { role: 'ROLE_EXECUTIVE', active: 'true' });
    }

    SearchInfoForm() {
        this.props.fetchformData('customerTabularPriceses', 'customerTabularPriceses', 'customerTabularPriceses?projection=tabularForForm');
        this.props.fetchExpensesData('expensesTabularPriceses', 'expensesTabularPriceses', 'expensesTabularPriceses?projection=expensesForForm');
    }

    CreateURL(table, filter, projection) {

        if (filter.includes("street")) { filter = filter.replace("street", "address.street"); }
        if (filter.includes("externalNumber")) { filter = filter.replace("externalNumber", "address.externalNumber"); }
        if (filter.includes("internalNumber")) { filter = filter.replace("internalNumber", "address.internalNumber"); }
        if (filter.includes("zipCode")) { filter = filter.replace("zipCode", "address.zipCode"); }
        if (filter.includes("colony")) { filter = filter.replace("colony", "address.colony"); }
        if (filter.includes("city")) { filter = filter.replace("city", "address.city"); }
        if (filter.includes("municipality")) { filter = filter.replace("municipality", "address.municipality"); }
        if (filter.includes("state")) { filter = filter.replace("state", "address.state"); }
        if (filter.includes("country")) { filter = filter.replace("country", "address.country"); }


        return (table.concat(filter).concat(projection));
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path, value: open });
        switch (path) {
            case 'NEW_CUSTOMER':
                this.props.saveCustomer(form);
                break;
            case 'NEW_TABULAR':
                this.props.saveTabularPriceses(form);
                break;
            case 'NEW_INVOICE_ITEM':
                this.props.saveInvoiceItem(form);
                break;
            default:
        }
    }

    render() {
        const {
            formOpen,
            conceptoOpen = false,
            tabuladorState,
            customers,
            notify,
            isLoading,
            customsHouses,
            executiveUsers,
            customerTabularPriceses,
            expensesTabularPriceses,
            activePage,
            numPages,
            showNotification,
            showMessage,
            notificationColor,
            pagePermissions,
            allowCreateTabular,
            allowReadTabular
        } = this.props;

        return (
            <div>
                <SubHeader
                    showRefresh={isLoading}
                    title="Clientes"
                    onPressHeaderButton={() => this.formHandler(true, 'formOpen')}
                    showAddButton={pagePermissions.create}
                    paginationConfig={{
                        numPages,
                        activePage,
                        notify: (page) => {
                            const { fetchData, userData: { userId } } = this.props;
                            fetchData('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name', page, ['executiveUser.id']: isExecutive() ? userId : '' });
                        }
                    }}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse"
                        data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <ClientesFilter
                        onSearch={(params) => {
                            const { fetchData, userData: { userId } } = this.props;
                            delete params.customerText;
                            Object.keys(params).forEach(key => params[key] === "" ? delete params[key] : '');

                            const useParams = {
                                ...params,
                                projection: 'denormalizedCustomer',
                                ['executiveUser.id']: isExecutive() ? userId : '',
                                sort: 'name'
                            };
                            fetchData('customers', 'customers', this.CreateURL('customers', serializeParams(useParams), ''));
                        }}
                        onClear={(params) => {
                            const { fetchData, userData: { userId } } = this.props;
                            fetchData('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name', ['executiveUser.id']: isExecutive() ? userId : '' });
                        }}
                    >
                        {
                            customers.length === 0 ? <EmptyList /> :
                                customers.map((customer, index) => {
                                    return (
                                        <Item
                                            key={index}
                                            customer={customer}
                                            allowUpdate={pagePermissions.update}
                                            allowDelete={pagePermissions.delete}
                                            allowCreateTabular={allowCreateTabular}
                                            allowReadTabular={allowReadTabular}
                                            onOpenInfoModal={() => {
                                                this.SearchInfoForm();
                                                notify({ op: 'update', path: 'tabuladorState', value: { tabuladorFormOpen: true, customer, index } })
                                            }}
                                            actions={{
                                                deleteCustomer: (value) => {
                                                    this.props.deleteCustomer(value, index);
                                                }
                                            }}
                                            executiveUsersList={executiveUsers.items}
                                            onSave={(newCustomer) => {
                                                //This is only updating the item on memory
                                                //Replace this with the action that saves results on server
                                                this.props.editCustomer(newCustomer, index);
                                            }}
                                        />
                                    );
                                })
                        }
                    </ClientesFilter>
                </div>
                <Form
                    title="Nuevo Cliente"
                    type="cliente"
                    open={formOpen}
                    actions={{}}
                    params={{ executiveUsers: this.props.executiveUsers }}
                    onModalClosed={() => this.formHandler(false, 'formOpen')}
                    onSave={(form) => {
                        this.formHandler(false, 'NEW_CUSTOMER', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />

                <TabuladorCustomForm
                    title="Tabulador"
                    className="tabulador"
                    open={tabuladorState.tabuladorFormOpen}
                    Actions={{
                        onAddPreInvoice: () => {
                            notify({ op: 'update', path: 'conceptoOpen', value: true });
                        }
                    }}
                    onSave={(data) => {
                        data['customer'] = tabuladorState.customer.id;
                        if (data.IsSaving == true) {
                            this.props.editTabularPriceses(data);
                        } else {
                            this.formHandler(false, 'NEW_TABULAR', data); //Creating a new Tabular
                        }
                        notify({ path: 'tabuladorState', value: { tabuladorFormOpen: false, customer: { ...tabuladorState.customer }, index: 0 } });
                    }}
                    onCancel={() => {
                        this.formHandler(false, 'tabuladorState>tabuladorFormOpen')
                    }}
                    autoScrollBodyContent
                    customsHouses={customsHouses}
                    customerTabularPriceses={customerTabularPriceses}
                    expensesTabularPriceses={expensesTabularPriceses}
                    tabuladorState={tabuladorState}
                    allowCreateTabular={allowCreateTabular}
                />
                <Form
                    title="Nuevo Concepto"
                    type="concepto"
                    open={conceptoOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'conceptoOpen')}
                    onSave={(form) => {
                        this.formHandler(false, 'NEW_INVOICE_ITEM', form);
                    }}//Will return if form is valid to send it
                />
            </div >
        );
    }
}

const mapStateToProps = ({ customersState, userData, userData: { permissions } }) => {
    return {
        ...customersState,
        userData,
        pagePermissions: getPagePermissions(CUSTOMERS_PERMISSION, permissions),
        allowCreateTabular: hasCreatePermission(TABULAR_PRICES_PERMISSION, permissions),
        allowReadTabular: hasReadPermission(TABULAR_PRICES_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Clientes);



// WEBPACK FOOTER //
// ./containers/clientes/index.js